import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './Diary.module.css'
import { PatientHomeDiaryEntry, PatientHomeDiaryNew } from 'PatientCareCenter/Home/Diary'
import { AddButton, ScrollDiv } from '_components';
import { diaryActions } from '_actions';

class PatientHomeDiary extends React.Component {

    render() {
        let oddEven = 0;
        return (
            <div className={styles.diary_wrapper}>
                {this.props.newVisible &&
                    <PatientHomeDiaryNew />
                }
                <div className={styles.diary_header}>
                    <div className={styles.spacer}></div>
                    <div className={styles.date}>Date</div>
                    <div className={styles.time}>Time</div>
                    <div className={styles.user}>User</div>
                    <div className={styles.entry}>Diary Entry</div>
                    <div className={styles.add_button}>
                        {!this.props.newVisible &&
                            <AddButton title='Add Diary Item...' size='extra-small' onClick={() => this.props.showDiary(this.props.ptno)} />
                        }
                    </div>
                </div>
                <ScrollDiv divId={this.props.ptno + '_PCC_HOME_DIARY'} className={styles.diary_body}>
                    {Object.keys(this.props.diaryEntries).length === 0 &&
                        <span className={styles.no_entries}>No Diary Items.</span>
                    }
                    {Object.keys(this.props.diaryEntries)
                        .map(id => {
                            const result = this.props.diaryEntries[id];
                            return (
                                <span key={result.id} className={styles.diary_entry} style={{ backgroundColor: (oddEven++ % 2) === 0 ? '#e6f9ff' : 'transparent' }}>
                                    <PatientHomeDiaryEntry id={result.id} />
                                </span>
                            )
                        })
                    }
                </ScrollDiv>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showDiary: bindActionCreators(diaryActions.showDiary, dispatch)
    };
}


function mapStateToProps(state) {
    return {
        diaryEntries: Object.keys(state.entities.diary)
            .filter(key => { return state.entities.diary[key].ptno === state.ui.patients.selectedPtno })
            .sort((a, b) => {
                return new Date(state.entities.diary[a].diaryDate).getTime() > new Date(state.entities.diary[b].diaryDate).getTime() ? -1 : 1;
            })
            .map(key => state.entities.diary[key]),
        newVisible: state.ui.diary[state.ui.patients.selectedPtno].newItemVisible,
        ptno: state.ui.patients.selectedPtno
    };
}

const connectedPatientHomeDiary = connect(mapStateToProps, mapDispatchToProps)(PatientHomeDiary);
export { connectedPatientHomeDiary as PatientHomeDiary };